<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" align-self="end">
        <v-btn color="info" @click="addNew"  v-if="$can('do','POKO_WizytyZabiegi_Edycja')">Dodaj kategorie</v-btn>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12">
        <v-data-table
            :items="kategorieZabiegow"
            :headers="headers"
            hide-default-footer
            disable-pagination
            style="margin-bottom:200px"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{props.item.nazwa}}</td>
              <td>{{props.item.grupujNaGlownymKalendarzu ? 'Tak' : 'Nie'}}</td>
              <td>
                <v-icon small class="mr-2" @click="editKategoria(props.item)" v-if="$can('do','POKO_WizytyZabiegi_Edycja')" title="Edytuj kategorie">fa-edit</v-icon>
                <v-icon small class="mr-2" @click="deleteKategoria(props.item.id)" v-if="$can('do','POKO_WizytyZabiegi_Edycja')" title="Usuń kategorie">fa-trash</v-icon>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog width="900px" v-if="showAddEdit" v-model="showAddEdit" persistent>
      <KategoriaEdit :zabieg="editedItem" @close="showAddEdit = false" @saved="saved"></KategoriaEdit>
    </v-dialog>

  </v-container>
</template>

<script>
import {mapActions} from "vuex";
import KategoriaEdit from "@/components/zabiegi/KategoriaEdit.vue";
import {zabiegiService} from "@/services";
import swal from "sweetalert";
export default {
  name: "ZabiegiKategorieLista",
  components: {KategoriaEdit},

  data() {
    return {
      kategorieZabiegow: [],
      headers: [
        {text: 'Nazwa',  align: 'left', value: 'nazwa'},
        {text: 'Grupuj na głównym kalendarzu', align: 'left', value:'grupujNaGlownymKalendarzu'},
        {text: 'Akcje', sortable: false, align: 'left', value: 'id'}
      ],
      showAddEdit: false,
      editedItem: {}
    }
  },
  mounted() {
    this.refreshList()
  },
  methods:
      {
        ...mapActions("alert", ["error", "success"]),
        refreshList()
        {
          zabiegiService.getKategorieZabiegow().then(result => {
            this.kategorieZabiegow = result.data.result
          }).catch(() => {
            this.error('Błąd pobierania listy kategorii zabiegów')
          })
        },
        addNew()
        {
          this.editedItem =  { id: 0, nazwa: ''}
          this.showAddEdit = true
        },
        saved()
        {
          this.refreshList()
          this.showAddEdit = false
        },
        editKategoria(item)
        {
          this.editedItem = item
          this.showAddEdit = true
        },
        deleteKategoria(id)
        {
          swal({
            title: "Czy na pewno?",
            text:
                "Czy na pewno chcesz usunąć ten zlecony zabieg?",
            icon: "warning",
            buttons: ["Nie", "Tak"],
            dangerMode: true
          }).then(confirmed => {
            if (confirmed) {
              zabiegiService.deleteKategoria(id).then(() => {
                this.refreshList()
              }).catch((err)=>{
                if (
                    err.response != null &&
                    err.response.data != null &&
                    err.response.data.error != null
                ) {
                  this.showError(false,err.response.data.error.message)
                } else {
                  this.showError(false,"Błąd usuwania kategorii.");
                }
              })
            }
          });

        }
      }
}
</script>

<style scoped>

</style>